import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext'; // Adjust the import path

const ManageUsers = () => {
  const navigate = useNavigate();
  const { isDarkMode, toggleTheme } = useContext(ThemeContext); // Get theme values

  return (
    <div className={`manage--user ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className='container'>
        <h1>Settings</h1>

        <button style={{ marginTop: '10px' }} onClick={() => navigate('/deleteAccount')}>
          Delete Account
        </button>

        <button style={{ marginTop: '10px' }} onClick={() => navigate('/resetPassword')}>
          Reset Password
        </button>

        <button style={{ marginTop: '10px' }} onClick={toggleTheme}>
          {isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        </button>

        <button style={{ marginTop: '10px' }} onClick={() => navigate('/createApiKey')}>
          Create API Key 
        </button>

        <button style={{ marginTop: '10px' }} onClick={() => navigate('/')}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ManageUsers;
